// extracted by mini-css-extract-plugin
module.exports = {"superElipse":"super-ellipse-skins-mediumOnConfined-superElipse-d21c73b2","strokeWidth":"super-ellipse-skins-mediumOnConfined-strokeWidth-04f63414"};